<script>
  export default {

    data() {
      return {
        single: null,
        multiple: null,
        options: ['Foo', 'Bar', 'Baz'],
        statusFail: null,
        statusSucceed: null,
      };
    },

    methods: {
      buttonHandle() {
        this.statusFail = 'loading';
        this.statusSucceed = 'loading';
        setTimeout(() => {
          this.statusFail = 'failed';
          this.statusSucceed = 'succeeded';
          setTimeout(() => {
            this.statusFail = null;
            this.statusSucceed = null;
          }, 1500);
        }, 2500);
      },
    },

  };
</script>
